var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24Withdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_24x24_withdraw"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.81006 2.50003C9.97255 2.50491 10.1267 2.57291 10.2399 2.68959C10.3531 2.80627 10.4164 2.96246 10.4163 3.12503V5.83336H16.0413C17.2996 5.83336 18.333 6.86679 18.333 8.12503V11.875C18.333 13.1333 17.2996 14.1667 16.0413 14.1667H10.4163V16.875C10.4163 16.9978 10.3801 17.1179 10.3122 17.2203C10.2444 17.3227 10.1478 17.4027 10.0347 17.4506C9.92161 17.4984 9.7969 17.5119 9.67619 17.4893C9.55547 17.4666 9.44409 17.409 9.35596 17.3234L2.27262 10.4484C2.21263 10.3902 2.16494 10.3205 2.13238 10.2434C2.09981 10.1664 2.08303 10.0836 2.08303 10C2.08303 9.9164 2.09981 9.83363 2.13238 9.75661C2.16494 9.67958 2.21263 9.60988 2.27262 9.55162L9.35596 2.67662C9.41597 2.61828 9.48709 2.57259 9.56509 2.54226C9.6431 2.51192 9.7264 2.49756 9.81006 2.50003ZM9.16634 4.60289L3.60563 10L9.16634 15.3972V13.5417C9.16636 13.3759 9.23221 13.217 9.34942 13.0998C9.46662 12.9826 9.62559 12.9167 9.79134 12.9167H16.0413C16.6239 12.9167 17.083 12.4576 17.083 11.875V8.12503C17.083 7.54243 16.6239 7.08336 16.0413 7.08336H9.79134C9.62559 7.08334 9.46662 7.01749 9.34942 6.90028C9.23221 6.78308 9.16636 6.62411 9.16634 6.45836V4.60289Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24Withdraw);
export default __webpack_public_path__ + "static/media/icn_24x24_withdraw.3db9646091ab6d2799ccbd8cc90c5603.svg";
export { ForwardRef as ReactComponent };